var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.85907 19.6123H9.51886C9.51886 20.1126 9.71763 20.5925 10.0714 20.9463C10.4252 21.3001 10.9051 21.4989 11.4055 21.4989C11.9058 21.4989 12.3857 21.3001 12.7395 20.9463C13.0933 20.5925 13.2921 20.1126 13.2921 19.6123H18.9519C19.202 19.6123 19.442 19.5129 19.6189 19.336C19.7958 19.1591 19.8952 18.9191 19.8952 18.669C19.8952 18.4188 19.7958 18.1788 19.6189 18.0019C19.442 17.825 19.202 17.7257 18.9519 17.7257V11.1226C18.9519 9.12114 18.1568 7.20168 16.7416 5.78646C15.3263 4.37124 13.4069 3.57617 11.4055 3.57617C9.40404 3.57617 7.48458 4.37124 6.06936 5.78646C4.65413 7.20168 3.85907 9.12114 3.85907 11.1226V17.7257C3.60889 17.7257 3.36896 17.825 3.19206 18.0019C3.01515 18.1788 2.91577 18.4188 2.91577 18.669C2.91577 18.9191 3.01515 19.1591 3.19206 19.336C3.36896 19.5129 3.60889 19.6123 3.85907 19.6123ZM5.74567 11.1226C5.74567 9.62149 6.34197 8.1819 7.40338 7.12049C8.4648 6.05907 9.90439 5.46277 11.4055 5.46277C12.9065 5.46277 14.3461 6.05907 15.4075 7.12049C16.469 8.1819 17.0653 9.62149 17.0653 11.1226V17.7257H5.74567V11.1226Z",
    fill: "#FF3D53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.4d654d8e01ea8272a5ecd14abf0b28a1.svg";
export { ForwardRef as ReactComponent };